import { render, staticRenderFns } from "./alertAction.vue?vue&type=template&id=4dde8d08&scoped=true&"
import script from "./alertAction.vue?vue&type=script&lang=js&"
export * from "./alertAction.vue?vue&type=script&lang=js&"
import style0 from "./alertAction.vue?vue&type=style&index=0&id=4dde8d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dde8d08",
  null
  
)

export default component.exports